import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { propertyJSONMeta as t } from "./property.js";

function r(r, o, e) {
  var i, n;
  return void 0 === o ? (n = r, i = [void 0]) : "string" != typeof o ? (n = r, i = [void 0], e = o) : (n = o, i = Array.isArray(r) ? r : [r]), function (r, o) {
    var p = r.constructor.prototype;

    var _iterator = _createForOfIteratorHelper(i),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var c = _step.value;

        var _i = t(r, c, n);

        _i.write && "object" == typeof _i.write || (_i.write = {}), e && (_i.write.target = e), _i.write.writer = p[o];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
}

export { r as writer };